/* Serious Money Only — product gallery (swipe / drag / arrows / dots) and variant picker */
(function () {
  function initGallery(gallery) {
    var track = gallery.querySelector('[data-smo-track]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-smo-slide]'));
    var prev = gallery.querySelector('[data-smo-prev]');
    var next = gallery.querySelector('[data-smo-next]');
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-smo-dot]'));
    var counter = gallery.querySelector('[data-smo-current]');
    var index = 0;

    function current() {
      return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    }

    function goTo(i) {
      if (!slides.length) return;
      var target = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
    }

    function sync() {
      index = current();
      dots.forEach(function (dot, i) {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = String(index + 1);
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= slides.length - 1;
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.getAttribute('data-smo-dot'), 10)); });
    });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
    });

    /* Mouse drag on desktop (touch devices swipe natively) */
    var startX = 0, startScroll = 0, dragging = false, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true; moved = false;
      startX = e.clientX; startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      var dx = e.clientX - startX;
      var base = Math.round(startScroll / Math.max(track.clientWidth, 1));
      if (dx < -50) goTo(base + 1);
      else if (dx > 50) goTo(base - 1);
      else goTo(base);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

    window.addEventListener('resize', function () {
      track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' });
    });

    sync();

    return {
      showMedia: function (mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mediaId)) { goTo(i); return; }
        }
      }
    };
  }

  document.querySelectorAll('[data-smo-product]').forEach(function (root) {
    var galleryEl = root.querySelector('[data-smo-gallery]');
    var gallery = galleryEl ? initGallery(galleryEl) : null;

    var select = root.querySelector('[data-smo-variant]');
    if (!select) return;
    var price = root.querySelector('[data-smo-price]');
    var compare = root.querySelector('[data-smo-compare]');
    var button = root.querySelector('[data-smo-add]');

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      if (price) price.textContent = option.getAttribute('data-price');
      if (compare) compare.textContent = option.getAttribute('data-compare') || '';
      var available = option.getAttribute('data-available') === 'true';
      if (button) {
        button.disabled = !available;
        button.textContent = available ? 'Add to bag' : 'Sold out';
      }
      if (gallery) gallery.showMedia(option.getAttribute('data-media-id'));
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    });
  });
})();
